import { render, staticRenderFns } from "./DataTableConsulta.vue?vue&type=template&id=01173fd8&scoped=true"
import script from "./DataTableConsulta.vue?vue&type=script&lang=js"
export * from "./DataTableConsulta.vue?vue&type=script&lang=js"
import style0 from "./DataTableConsulta.vue?vue&type=style&index=0&id=01173fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01173fd8",
  null
  
)

export default component.exports